import React from 'react';
import Slider from 'react-slick';
import AbstractaLogo from '../../../assets/sponsors/abstracta.png';
import Ande10Logo from '../../../assets/sponsors/ande-10.png';
import AniiLogo from '../../../assets/sponsors/anii.svg';
import BidLogo from '../../../assets/sponsors/BID.png';
import CentenarioLogo from '../../../assets/sponsors/CENTENARIO.svg';
import Citi2025Logo from '../../../assets/sponsors/Citi-2025.svg';
import Cubo2025Logo from '../../../assets/sponsors/cubo-2025.png';
import Deel2024Logo from '../../../assets/sponsors/deel-2024.png';
import DLocalLogo from '../../../assets/sponsors/DLocal_logo.png';
import Domus2025Logo from '../../../assets/sponsors/domus-2025.png';
import EResidencyLogo from '../../../assets/sponsors/e-residency.png';
import ElPaisLogo from '../../../assets/sponsors/elpais.png';
import GratefulLogo from '../../../assets/sponsors/Grateful.svg';
import HelloLogo from '../../../assets/sponsors/hello.png';
import JetmarLogo from '../../../assets/sponsors/jetmar.png';
import LATULogo from '../../../assets/sponsors/latu.svg';
import WillinLogo from '../../../assets/sponsors/logo-willin.png';
import LuceroLogo from '../../../assets/sponsors/lucero.png';
import Prex10Logo from '../../../assets/sponsors/prex10.png';
import RuaLogo from '../../../assets/sponsors/rua.png';
import SenpaiLogo from '../../../assets/sponsors/senpai-new.svg';
import UCU40Logo from '../../../assets/sponsors/ucu-40.svg';
import UruguayInnovaLogo from '../../../assets/sponsors/uruguay-innova.png';
import UruguayXXILogo from '../../../assets/sponsors/uruguay-xxi.png';
import ZetaSoftwareLogo from '../../../assets/sponsors/zetasoftware.svg';

type SponsorTag =
  | 'Presenter'
  | 'Powered by'
  | 'Gold'
  | 'Silver'
  | 'Bronze'
  | 'Media Partner'
  | 'Travel Partner'
  | 'Organizer'
  | 'Support';

type Sponsor = {
  name: string;
  logo: string;
  tag?: SponsorTag;
};

const logos: Sponsor[] = [
  // Presenter / Powered
  { name: 'CITI', logo: Citi2025Logo, tag: 'Presenter' },
  { name: 'DLOCAL', logo: DLocalLogo, tag: 'Powered by' },
  { name: 'Lucero', logo: LuceroLogo, tag: 'Organizer' },

  // Gold
  { name: 'DOMUS GLOBAL', logo: Domus2025Logo, tag: 'Gold' },
  { name: 'GRATEFUL By Exodus', logo: GratefulLogo, tag: 'Gold' },
  { name: 'THE GRAND HOTEL', logo: '', tag: 'Gold' },
  { name: 'Bursera Capital', logo: '', tag: 'Gold' },

  // Silver
  { name: 'BID', logo: BidLogo, tag: 'Silver' },
  { name: 'DEEL', logo: Deel2024Logo, tag: 'Silver' },
  { name: 'HIKKO', logo: '', tag: 'Silver' },
  { name: 'RUA ASISTENCIA', logo: RuaLogo, tag: 'Silver' },

  // Bronze
  { name: 'E-RESIDENCY', logo: EResidencyLogo, tag: 'Bronze' },
  { name: 'ORT', logo: '', tag: 'Bronze' },

  // Support
  { name: 'CUBO', logo: Cubo2025Logo, tag: 'Support' },
  { name: 'WILLINN', logo: WillinLogo, tag: 'Support' },
  { name: 'HELLO HELLO', logo: HelloLogo, tag: 'Support' },
  { name: 'URUGUAY INNOVA', logo: UruguayInnovaLogo, tag: 'Support' },
  { name: 'ANII', logo: AniiLogo, tag: 'Support' },
  { name: 'LATU', logo: LATULogo, tag: 'Support' },
  { name: 'ANDE', logo: Ande10Logo, tag: 'Support' },
  { name: 'URUGUAY XXI', logo: UruguayXXILogo, tag: 'Support' },
  { name: 'UCU', logo: UCU40Logo, tag: 'Support' },
  { name: 'ABSTRACTA', logo: AbstractaLogo, tag: 'Support' },
  { name: 'MEDICINA PERSONALIZADA', logo: '', tag: 'Support' },
  { name: 'SENPAI', logo: SenpaiLogo, tag: 'Support' },
  { name: 'CENTENARIO', logo: CentenarioLogo, tag: 'Support' },
  { name: 'PREX', logo: Prex10Logo, tag: 'Support' },
  { name: 'ZETASOFTWARE', logo: ZetaSoftwareLogo, tag: 'Support' },

  // Partners
  { name: 'JETMAR', logo: JetmarLogo, tag: 'Travel Partner' },
  { name: 'EL PAÍS', logo: ElPaisLogo, tag: 'Media Partner' },
];

const tagStyles: Record<
  SponsorTag,
  { className: string; style?: React.CSSProperties }
> = {
  Presenter: {
    className: 'text-white border border-white/30 shadow-lg',
    style: {
      backgroundImage:
        'linear-gradient(135deg, #ff5a79 0%, #6b32ff 55%, #1a7bff 100%)',
    },
  },
  'Powered by': {
    className: 'text-white border border-white/25 shadow-lg',
    style: {
      backgroundImage:
        'linear-gradient(135deg, #1a7bff 0%, #6b32ff 45%, #ff5a79 100%)',
    },
  },
  Gold: {
    className: 'bg-primary/10 text-primary border border-primary/30 shadow-sm',
  },
  Silver: {
    className:
      'bg-secondary/20 text-secondary border border-secondary/30 shadow-sm',
  },
  Bronze: {
    className: 'bg-[#f9dfc5] text-[#7a3816] border border-[#f3caa0] shadow-sm',
  },
  'Media Partner': {
    className: 'bg-indigo-900/80 text-white border border-white/20 shadow',
  },
  'Travel Partner': {
    className: 'bg-accent/20 text-accent border border-accent/30 shadow-sm',
  },
  Organizer: {
    className:
      'bg-emerald-100 text-emerald-700 border border-emerald-200 shadow-sm',
  },
  Support: {
    className:
      'bg-white/80 text-slate-500 border border-slate-200 shadow-sm',
  },
};

const tagLabels: Partial<Record<SponsorTag, string>> = {};

export const SponsorsCarousel: React.FC = () => {
  const [slidesToShow, setSlidesToShow] = React.useState(5);
  const [scrollSpeed, setScrollSpeed] = React.useState(12000);

  React.useEffect(() => {
    const computeSlides = () => {
      const width = typeof window !== 'undefined' ? window.innerWidth : 1024;
      if (width <= 360) return 1;
      if (width <= 480) return 2;
      if (width <= 768) return 3;
      if (width <= 940) return 4;
      return 5;
    };
    const computeSpeed = () => {
      const width = typeof window !== 'undefined' ? window.innerWidth : 1024;
      if (width <= 480) return 3000; // más rápido en móvil
      return 6000; // acelera un poco en desktop/tablet
    };
    setSlidesToShow(computeSlides());
    setScrollSpeed(computeSpeed());

    const onResize = () => {
      setSlidesToShow(computeSlides());
      setScrollSpeed(computeSpeed());
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const settings = React.useMemo(
    () => ({
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: scrollSpeed,
      cssEase: 'linear',
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: true,
      touchMove: true,
      adaptiveHeight: false,
      variableWidth: false,
      centerMode: false,
      slidesToShow,
      slidesToScroll: 1,
    }),
    [slidesToShow, scrollSpeed]
  );

  return (
    <div className="w-full flex justify-center mb-12">
      <div
        className="relative overflow-hidden mask-fade"
        style={{ width: '100%' }}
      >
        <Slider {...settings}>
          {['mono', 'color'].map((variant) =>
            logos.map((s, i) => {
              const tag = s.tag;
              const badge = tag ? tagStyles[tag] : null;

              return (
                <div key={`${s.name}-${variant}-${i}`} className="px-4 md:px-6">
                  <div className="relative flex items-center justify-center h-16 md:h-24">
                    {tag && badge && (
                      <span
                        className={`z-10 absolute left-1 top-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${badge.className}`}
                        style={badge.style}
                      >
                        {tagLabels[tag] ?? tag}
                      </span>
                    )}
                    <img
                      style={
                        variant === 'mono'
                          ? { transform: 'grayscale(100%)' }
                          : undefined
                      }
                      src={s.logo}
                      alt={s.name}
                      className="max-h-12 md:max-h-14 max-w-[120px] md:max-w-[180px] w-auto h-auto object-contain select-none pointer-events-none opacity-90"
                      loading="lazy"
                      decoding="async"
                      draggable={false}
                    />
                  </div>
                </div>
              );
            })
          )}
        </Slider>
      </div>

      <style>{`
        .mask-fade {
          -webkit-mask-image: linear-gradient(to right, transparent 0, black 32px, black calc(100% - 32px), transparent 100%);
                  mask-image: linear-gradient(to right, transparent 0, black 32px, black calc(100% - 32px), transparent 100%);
        }
        @media (min-width: 768px) {
          .mask-fade {
            -webkit-mask-image: linear-gradient(to right, transparent 0, black 50px, black calc(100% - 50px), transparent 100%);
                    mask-image: linear-gradient(to right, transparent 0, black 50px, black calc(100% - 50px), transparent 100%);
          }
        }
      `}</style>
    </div>
  );
};